(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/pix-mix/components/pix-mix-view/assets/javascripts/pix-mix-closed.js') >= 0) return;  svs.modules.push('/modules/pix-mix/components/pix-mix-view/assets/javascripts/pix-mix-closed.js');
"use strict";

var _svs$pix_mix$data;

const {
  PixMixImage
} = svs.pix_mix.components.pixmixView;
const {
  image: cmsImage,
  closedTitle
} = ((_svs$pix_mix$data = svs.pix_mix.data) === null || _svs$pix_mix$data === void 0 ? void 0 : _svs$pix_mix$data.initialState) || {};
const PixMixClosed = _ref => {
  let {
    className
  } = _ref;
  return React.createElement("div", null, React.createElement("div", {
    className: "".concat(className, " pix-mix-view")
  }, React.createElement("h2", {
    className: "pix-mix-title"
  }, "Snart \xF6ppnar PIX-mixen igen"), cmsImage && React.createElement(PixMixImage, null), closedTitle && React.createElement("h3", {
    className: "pix-mix-closedtitle"
  }, "Spelen \xF6ppnar:", React.createElement("br", null), React.createElement("span", {
    className: "f-bold"
  }, closedTitle))));
};
setGlobal('svs.pix_mix.components.pixmixView.PixMixClosed', PixMixClosed);

 })(window);